const painsTop = [
  {
    emoji: "⏰",
    title: "Mentoren missen tijd",
    text: "De wil om persoonlijk te begeleiden is er. De ruimte in het rooster niet.",
  },
  {
    emoji: "👀",
    title: "Ontwikkeling is onzichtbaar",
    text: "Hoe een leerling zich echt ontwikkelt, blijft vaak moeilijk te zien.",
  },
  {
    emoji: "📄",
    title: "LOB raakt versnipperd",
    text: "Opdrachten, tests en gesprekken staan verspreid over losse plekken.",
  },
];

const painsBottom = [
  {
    emoji: "🎯",
    title: "Keuzes worden te laat gemaakt",
    text: "De oriëntatie krijgt soms pas laat echt aandacht, terwijl zelfkennis tijd nodig heeft.",
  },
  {
    emoji: "📊",
    title: "Minder grip op voortgang",
    text: "Mentoren zien niet altijd hoe ver een leerling is, of opdrachten écht zijn gedaan en inzet wordt getoond.",
  },
];

const PainSection = () => {
  return (
    <section className="relative py-20 lg:py-28 bg-secondary text-primary-foreground animate-on-scroll overflow-hidden">
      <div className="pointer-events-none absolute -top-24 right-0 w-[420px] h-[420px] rounded-full bg-primary/20 blur-[140px]" />
      <div className="pointer-events-none absolute bottom-0 -left-20 w-80 h-80 rounded-full bg-warm/10 blur-[130px]" />

      <div className="container mx-auto max-w-6xl px-4 sm:px-6 relative">
        <div className="max-w-2xl mx-auto text-center mb-12">
          <span className="inline-block text-[11px] font-bold tracking-[0.2em] uppercase text-warm mb-3 px-3 py-1 bg-warm/15 rounded-full">
            Het probleem
          </span>
          <h2 className="text-3xl lg:text-[2.4rem] font-extrabold leading-[1.15] [text-wrap:balance]">
            Goede LOB begint met de juiste begeleiding — niet met meer
            administratie.
          </h2>
        </div>


        <div className="grid lg:grid-cols-3 gap-4 mb-4">
          {painsTop.map((p) => (
            <Card key={p.title} emoji={p.emoji} title={p.title} text={p.text} />
          ))}
        </div>

        <div className="grid lg:grid-cols-2 gap-4 lg:max-w-[52rem] lg:mx-auto">
          {painsBottom.map((p) => (
            <Card key={p.title} emoji={p.emoji} title={p.title} text={p.text} />
          ))}
        </div>
        {/* bridge line */}
        <p className="mt-12 text-xl lg:text-2xl font-extrabold max-w-3xl mx-auto text-center leading-tight">
          Daarom ontwikkelden wij{" "}
          <span className="text-primary">studie connect.</span>{" "}
          Hier maken wij écht het verschil.
        </p>

      </div>
    </section>
  );
};

const Card = ({
  emoji,
  title,
  text,
}: {
  emoji: string;
  title: string;
  text: string;
}) => (
  <div className="group bg-primary-foreground/5 rounded-2xl border border-primary-foreground/10 p-5 hover:bg-primary-foreground/10 hover:border-primary-foreground/20 transition-all">
    <div className="flex items-start gap-4">
      <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-primary-foreground/10 flex items-center justify-center text-xl group-hover:scale-110 transition-transform">
        {emoji}
      </div>
      <div className="min-w-0">
        <h3 className="text-[15px] font-bold mb-1 leading-snug [text-wrap:balance]">
          {title}
        </h3>
        <p className="text-sm text-primary-foreground/75 leading-relaxed">
          {text}
        </p>
      </div>
    </div>
  </div>
);

export default PainSection;
